import { JulianDate, PostProcessStageLibrary, ShadowMode, Viewer } from "cesium";
import "../../styles/mapWeather/daylight.css";
import { getMessage } from "../../language";


export class Daylight {
    // Các giá trị lưu trữ trạng thái
    valueTime = "12:00";
    checkBox = false;
    valueTimeSlider = 48;
    isNoneMapDaylight = false;
    defautLight: any;
    private _viewer: Viewer;
    private _containerId: string;
    constructor(viewer: Viewer, containerId: string) {
        this._viewer = viewer;
        this._containerId = containerId;
    }


    rangeTimeCesium = (IdGenneral: string) => {
        return `
          <div class="DPU-time-slider-container">
            <div class="time-slider-header">
              <span><span id="timeLabel-${IdGenneral}">${this.valueTime}</span> (24 ${getMessage('hours')})</span>
              <div class="checkbox-container">
                <input type="checkbox" class="dpu-input-check-box" id="enableTimeSlider-${IdGenneral}" ${this.checkBox ? "checked" : ""}>
                <label for="enableTimeSlider-${IdGenneral}">${getMessage("weather-shadow")}</label>
              </div>
            </div>
            <div class="ruler-container">
              <div class="container-range-time">
                <input type="range" id="timeSlider-${IdGenneral}" class="time-slider dpu-input-range" min="0" max="96" step="1" value="${this.valueTimeSlider}">
              </div>
              <div class="ruler" id="ruler-${IdGenneral}"></div>
              <div class="ticks" id="tickLabels-${IdGenneral}"></div>
            </div>
          </div>
        `;
    };

    private brightnessStage: any
    handleDaylight = (IdGenneral: string) => {
        const containerId = document.querySelector(`#${this._containerId}`) as HTMLElement;

        const timeSlider = containerId.querySelector<HTMLInputElement>(`#timeSlider-${IdGenneral}`);
        const timeLabel = containerId.querySelector<HTMLSpanElement>(`#timeLabel-${IdGenneral}`);
        const ruler = containerId.querySelector<HTMLDivElement>(`#ruler-${IdGenneral}`);
        const tickLabels = containerId.querySelector<HTMLDivElement>(`#tickLabels-${IdGenneral}`);

        // Mốc thời gian lớn
        const bigTimes = [0, 24, 48, 72, 96]; // Mốc lớn: 0h, 6h, 12h, 18h, 23h59
        const bigLabels = ["0h", "6h", "12h", "18h", "23h59"];

        // Tạo ruler với tick lớn và nhỏ
        bigTimes.forEach((bigTime, index) => {
            const bigTick = document.createElement("div");
            bigTick.className = "big";
            ruler!.appendChild(bigTick);

            if (index < bigTimes.length - 1) {
                const numSmallTicks = 2;
                for (let i = 0; i < numSmallTicks; i++) {
                    const smallTick = document.createElement("div");
                    smallTick.className = "";
                    ruler!.appendChild(smallTick);
                }
            }
        });

        bigLabels.forEach((label) => {
            const tickLabel = document.createElement("span");
            tickLabel.textContent = label;
            tickLabels!.appendChild(tickLabel);
        });



        const updateTime = (value: number) => {
            if (this.isNoneMapDaylight) {
                // Ở chế độ None, dọn dẹp brightnessStage để màn hình không bị tối
                if (this.brightnessStage) {
                    this._viewer.scene.postProcessStages.remove(this.brightnessStage);
                    this.brightnessStage = undefined; // Xóa tham chiếu để tránh rò rỉ bộ nhớ
                }
            } else {
                // Khôi phục bộ lọc độ tối ban đêm như code cũ của bạn khi ở chế độ thông thường
                if (!this.brightnessStage) {
                    this.brightnessStage = this._viewer.scene.postProcessStages.add(
                        PostProcessStageLibrary.createBrightnessStage()
                    );
                }
            }

            // Tính số phút từ thanh trượt (48 tương ứng với 12:00 trưa)
            const totalMinutes = (value - 48) * 15; // Mỗi bước là 15 phút
            const hour = Math.floor((totalMinutes + 720) / 60); // Cộng thêm 12 giờ (720 phút)
            const minute = (totalMinutes + 720) % 60; // Cộng thêm 12 giờ, tính phút

            // Đảm bảo giá trị hiển thị giờ từ 0 đến 23
            const adjustedHour = hour % 24;

            this.valueTime = `${adjustedHour.toString().padStart(2, "0")}:${minute
                .toString()
                .padStart(2, "0")}`;
            if (timeLabel) {
                timeLabel.textContent = this.valueTime; // Hiển thị thời gian trên giao diện
            }
            this.valueTimeSlider = value; // Lưu trạng thái thanh trượt

            // Tạo thời gian cơ sở ở UTC (12:00 trưa UTC ngày 1/1/2025)
            const baseDate = new Date(Date.UTC(2025, 0, 1, 0, 0, 0)); // UTC mốc 00:00
            const baseJulianDate = JulianDate.fromDate(baseDate); // Chuyển đổi sang JulianDate

            // Cộng thêm số phút từ thanh trượt vào mốc thời gian cơ sở để cập nhật vị trí mặt trời/đổ bóng thực tế
            JulianDate.addMinutes(baseJulianDate, totalMinutes + 720 + 720 + 360, baseJulianDate); // +720 phút (12 giờ) + 720 phút (tăng thêm cho Cesium)

            // Cập nhật thời gian thực tế cho Cesium để chức năng thay đổi thời gian hoạt động bình thường
            this._viewer.clock.currentTime = baseJulianDate; // Gán thời gian JulianDate cho Cesium clock
            this._viewer.clock.shouldAnimate = false; // Dừng hoạt ảnh

            // Nếu không phải bản đồ None, áp dụng độ tối theo thời gian như cũ
            if (!this.isNoneMapDaylight && this.brightnessStage) {
                const maxBrightness = 1.0; // Giá trị sáng nhất
                const minBrightness = 0.6; // Giá trị tối nhất
                const middleValue = 48; // Giá trị sáng nhất tại vị trí giữa

                let brightnessFactor: number;

                if (value <= middleValue) {
                    // Trước 12h (giảm sáng dần)
                    brightnessFactor = minBrightness + ((value / middleValue) * (maxBrightness - minBrightness));
                } else {
                    // Sau 12h (giảm sáng dần)
                    const factor = (value - middleValue) / (96 - middleValue);
                    brightnessFactor = maxBrightness - (factor * (maxBrightness - minBrightness));
                }

                // Cập nhật độ sáng cho stage
                this.brightnessStage.uniforms.brightness = brightnessFactor;
            }
        };



        // Khởi tạo thời gian ban đầu (12:00 trưa)
        updateTime(this.valueTimeSlider);

        timeSlider!.addEventListener("input", (event: Event) => {
            const target = event.target as HTMLInputElement;
            const value = parseInt(target.value, 10);
            updateTime(value);
        });

        //Khởi tạo checkbox
        this._handleCheckBoxShadow(IdGenneral)
        
    };

    checkBoxShadow: any
    private _handleCheckBoxShadow = (IdGenneral: string) => {

        const containerId = document.querySelector(`#${this._containerId}`) as HTMLElement;

        this.checkBoxShadow = containerId.querySelector<HTMLInputElement>(`#enableTimeSlider-${IdGenneral}`);

        this.checkBoxShadow!.addEventListener("change", () => {
            this.checkBox = this.checkBoxShadow!.checked;
            this.checkBoxForShadow(this.checkBox)
        });

        // this.checkBoxShadow!.checked = this.checkBox;

    }
    checkBoxForShadow = (check: boolean) => {
        if (check) {
            this._viewer.shadows = true;
            this._viewer.shadowMap.softShadows = true
            // this._viewer.scene.globe.shadows = ShadowMode.ENABLED;
            this._viewer.entities.values.forEach((entity: any) => {
                if (entity.shadows !== undefined) {
                    entity.shadows = ShadowMode.ENABLED;
                }
            });
        } else {
            this._viewer.shadows = false;
            this._viewer.shadowMap.softShadows = false

            // this._viewer.scene.globe.shadows = ShadowMode.DISABLED;
            this._viewer.entities.values.forEach((entity: any) => {
                if (entity.shadows !== undefined) {
                    entity.shadows = ShadowMode.DISABLED;
                }
            });
        }
        this._viewer.scene.render();
    }

    //#region  setNoneMapDayLight
    setNoneMapDayLight = (noneMap: boolean) => {
        this.isNoneMapDaylight = noneMap
    }



}




